import * as actionType from "../types/ActionTypes";

const initialState = {
  coursereg: [],
  postCoursereg: [],
  error: false,
  isLoading: false,
  isPostLoading: false,
  isUpdateLoading: false,
};

export const Coursereg = (state = initialState, action) => {
  switch (action.type) {
    case actionType.COURSE_REG_SET_DATA:
      return {
        ...state,
        coursereg: action.coursereg,
        error: false,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };

    case actionType.COURSE_REG_FAIL_DATA:
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.COURSE_REG_LOADING:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case actionType.COURSE_REG_POST_LOADING:
      return {
        ...state,
        isPostLoading: true,
        error: false,
      };
    case actionType.COURSE_REG_POST_LOADING_RESET:
      return {
        ...state,
        isPostLoading: false,
        error: false,
      };
    case actionType.COURSE_REG_UPDATE_LOADING:
      return {
        ...state,
        isUpdateLoading: true,
        error: false,
      };
    case actionType.POST_COURSE_REG_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.POST_COURSE_REG_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        postCoursereg: action.postCoursereg,
      };
    case actionType.UPDATE_COURSE_REG_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_COURSE_REG_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_COURSE_REG_DATA_START:
      return {
        ...state,
      };

    default:
      return state;
  }
};
